import { useNavigate } from 'react-router';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FarmsIcon, RoomCardIcon } from '../utility/CustomSvgIcons';
import { cardClasses } from '../utility/constants';

export default function FarmCard(props) {
  const navigate = useNavigate();

  const {
    id = '',
    farm_name = 'Unknown',
    farm_alias = '',
    frtl = `${farm_alias}.0.0.0`,
    license_number = 'Unknown',
    alias_room_count = 0,
    room_count = 0,
    currDarkThemeClass = '',
  } = props;

  const farmCardPaperProps = {
    'aria-label': `See ${farm_name} detail page`,
    className: `${cardClasses?.farm?.paper} ${currDarkThemeClass} farmsTabContent`,
    onClick: () => navigate(`/configurations/farm/${id}/`),
    role: 'button',
    square: true,
    variant: 'none',
  };

  const farmCardIconProps = {
    className: `${cardClasses?.farm?.icon} ${currDarkThemeClass}`,
  };

  const farmCardNameTypoProps = {
    className: `${cardClasses?.farm?.nameTypo} ${currDarkThemeClass}`,
  };

  const farmCardCountTypoProps = {
    className: `${cardClasses?.farm?.countTypo} ${currDarkThemeClass}`,
  };

  const farmCardRoomIconProps = {
    className: `${cardClasses?.farm?.roomIcon} ${currDarkThemeClass}`,
  };

  const farmCardLicenseTypoProps = {
    className: `${cardClasses?.farm?.countTypo} ${currDarkThemeClass}`,
    sx: { display: 'flex', justifyContent: 'flex-end' },
  };

  return (
    <Paper {...farmCardPaperProps}>
      <Typography {...farmCardLicenseTypoProps}>License: {license_number}</Typography>
      <Typography {...farmCardLicenseTypoProps}>Farm Alias: {farm_alias}</Typography>
      <Typography {...farmCardLicenseTypoProps}>FRTL: {frtl}</Typography>
      <FarmsIcon {...farmCardIconProps} />
      <Typography {...farmCardNameTypoProps}>{farm_name}</Typography>
      <Typography {...farmCardCountTypoProps}>
        {/* <HexagonOutlinedIcon sx={{color: 'primary.800', transform: 'rotateZ(90deg)'}} />&nbsp; */}
        <RoomCardIcon {...farmCardRoomIconProps} />
        {alias_room_count} Rooms ({room_count} Metrc Rooms Location)
      </Typography>
    </Paper>
  );
}
